import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { ApprovalFeedbackRequest, ApprovalFeedbackResponse } from '@/app/components/global/dialog-boxes/approval-feedback/approval-feedback.component';

import { ProjectStageApproverResponse } from '../../interfaces/project-stage-approver.interface';

@Injectable({
  providedIn: 'root'
})
export class ProjectStageApprovalService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Fetch specific stage approvals
  getProjectStageApprovals(projectId: number,stage: number): Observable<ProjectStageApproverResponse> {
    return this.http.post<ProjectStageApproverResponse>(
      `${this.apiUrl}/get-project-stage-approvers/${projectId}/${stage}`,
      {}
    );
  }


  updateApprovalFeedback(data: ApprovalFeedbackRequest): Observable<ApprovalFeedbackResponse> {
    return this.http.post<ApprovalFeedbackResponse>(
      `${this.apiUrl}/save-project-stage-approval-feedback`,
      data
    );
  }

}
